import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackCommentChanged } from 'state/missed-deal-feeedback/actions';
import { getFeedbackComment } from 'state/missed-deal-feeedback/selectors';

export function Comment({ formId }: FormIdProps) {
  const { formatMessage } = useIntl();
  const comment = useAppSelector(state => getFeedbackComment(state, formId) ?? '');
  const [value, setValue] = useState<string>(comment);
  const dispatch = useThunkDispatch();

  return (
    <textarea
      className="form-control flex-grow-1"
      data-e2e="feedback-comment"
      value={value}
      onChange={e => setValue(e.target.value)}
      onBlur={() => {
        if (value !== comment) {
          dispatch(missedDealFeedbackCommentChanged(formId, value));
        }
      }}
      placeholder={formatMessage({ id: 'missedDealFeedback.commentPlaceholder' })}
      rows={10}
    />
  );
}
